function sendMessage(message) {
  if (window.parent && window !== window.parent) {
    window.parent.postMessage(JSON.stringify(message), "*");
  }
}

function parseMessage(message) {
  const funcList = [
    "parseUrl",
    "couldRetry",
    "writerCustomStyle",
    "powerpointCustomStyle",
    "wpsAd",
    "wordAd",
    "etAd",
    "wppAd"
  ];
  try {
    return JSON.parse(message, function(k, v) {
      if (k.indexOf && funcList.indexOf(k) > -1) {
        v = new Function(`return ${v}`)();
      }
      return v;
    });
  } catch (err) {
    return null;
  }
}

function trim(str) {
  return String.prototype.trim === 'function' ? String.prototype.trim(str)
    : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

function isEmpty(str) {
  return typeof str === 'undefined' ||
    str === null ||
    typeof str === 'number' && isNaN(str) ||
    (typeof str === 'string' && trim(str) === '');
}

function initOSSInstance(openapi, ossParams) {
  const {
    endpoint,
    region,
    bucket,
    accessKeyId,
    accessKeySecret,
    stsToken
  } = ossParams;

  if ((endpoint || region && bucket) && accessKeyId && accessKeySecret && stsToken) {
    const client = new OSS({
      endpoint,
      region,
      accessKeyId,
      accessKeySecret,
      stsToken,
      bucket,
      secure: location.protocol == "https:",
      cname: !isEmpty(endpoint)
    });

    openapi.setConfig({
      client
    });

    return client;
  }
}

export const ERROR = {
  CODE: {
    InvalidAccessKeyId: -1002, // AK无效
    AccessDenied: -1003, // token过期或者无权限访问bucket
    InvalidSecurityToken: -1004, // 无效的stsToken
    SecurityTokenExpired: -1005, // sts token过期
    SignatureDoesNotMatch: -1006, // 签名错误
    Cors: -1007, // 未配置跨域
    Refers: -1008, // Refers配置有误
    default: -1100 // 其他错误
  },
  MSG: {
    default: '服务器错误，请稍后重试或联系管理员',
    404: '文件不存在或已删除',
    403: '无权限访问此文件或授权已过期'
  }
};

module.exports = {
  sendMessage,
  parseMessage,
  trim,
  isEmpty,
  initOSSInstance,
  ERROR
}